export function debounce<T>(fn: Function, ms = 400) {
    let timeoutId: ReturnType<typeof setTimeout>;

    return (...args: T[]) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => fn(...args), ms);
    };
}

export function wait(fn: Function, ms = 400) {
    return () => {
        setTimeout(() => {
            fn();
        }, ms);
    };
}

export async function delay(ms = 200): Promise<void> {
    const smallDelay = new Promise((resolve) => setTimeout(resolve, ms));
    await smallDelay;
}
